/* eslint-disable */
export default {
    namespaced: true,
    state: () => ({
        providers: [],
        slotProviders: [],
        fishProviders: [],
        arcadeProviders: [],
        liveProviders: [],
        sportProviders: [],
        isProvidersFetching: false,
    }),

    mutations: {
        SET_PROVIDERS(state, providers) {
            state.providers = providers;

            state.slotProviders = providers.filter((p) =>
                p.category_code?.toUpperCase().includes("SLOTS")
            );
            state.fishProviders = providers.filter((p) =>
                p.category_code?.toUpperCase().includes("FISH")
            );

            state.arcadeProviders = providers.filter((p) => {
                return p.category_code?.includes("MINI") || p.category_code?.includes("POKER");
            });

            state.liveProviders = providers.filter((p) =>
                p.category_code?.toUpperCase().includes("LIVE")
            );
            state.sportProviders = providers.filter((p) =>
                p.category_code?.toUpperCase().includes("SPORT")
            );
        },

        SET_IS_PROVIDERS_FETCHING(state, status) {
            state.isProvidersFetching = status;
        },
    },

    actions: {
        async fetchActiveProviders({ commit }) {
            commit("SET_IS_PROVIDERS_FETCHING", true);
            try {
                const res = await axios.get("/providers", {
                    params: { status: "active" },
                });
                commit("SET_PROVIDERS", res.data.data || []);
            } catch (e) {
                console.error(e);
                commit("SET_PROVIDERS", []);
            } finally {
                commit("SET_IS_PROVIDERS_FETCHING", false);
            }
        },
    },
};
